import { createContext, useContext, useEffect, useState } from "react";
import backofficeAxiosInstance from "../api/backoffice.api";
import { useRCN } from "./RCNContext";
import useLatestRequest from "../hooks/useLatestRequest";

const MenuAccessContext = createContext();

export const useMenuAccess = () => useContext(MenuAccessContext);

export const MenuAccessProvider = ({ children }) => {
    const {RCN} = useRCN();
    const [permissions, setPermissions] = useState(null);
    const [loading, setLoading] = useState(true);
    const runLatestRequest = useLatestRequest();

    const refreshPermissions = async (targetUid) => {
        const effectiveUid = targetUid || new URLSearchParams(window.location.search).get("id") || localStorage.getItem("locationId");
        if (!effectiveUid) return;

        return runLatestRequest(
            async () => {
                setLoading(true);
                const response = await backofficeAxiosInstance.get(`/menu-access/location/${effectiveUid}`);
                const data = response.data || {};

                // Mobile App / Notifications visibility check (runs in background without blocking core permissions)
                const effectiveRcn = RCN || localStorage.getItem("RCN");
                if (effectiveRcn && String(effectiveRcn).trim().length > 0) {
                    backofficeAxiosInstance.get(`/notifications/mobile-app-status?rcn=${effectiveRcn}`)
                        .then((mobileAppResponse) => {
                            const hasNotification = Boolean(mobileAppResponse.data?.notification);
                            setPermissions((prev) => (prev ? { ...prev, mobileApp: hasNotification } : prev));
                        })
                        .catch(() => {
                            // Default to false on failure without blocking
                        });
                }
                return data;
            },
            {
                onSuccess: (data) => {
                    setPermissions(data);
                    setLoading(false);
                },
                onError: () => {
                    setPermissions(null);
                    setLoading(false);
                },
                onFinally: () => {
                    setLoading(false);
                }
            }
        );
    };

    useEffect(() => {
        const currentLocUid = new URLSearchParams(window.location.search).get("id") || localStorage.getItem("locationId");
        if (currentLocUid && RCN && String(RCN).trim()?.length > 0) {
            refreshPermissions(currentLocUid);
        }
    }, [RCN]);

  return (
    <MenuAccessContext.Provider value={{ permissions, setPermissions, loading, refreshPermissions }}>
      {children}
    </MenuAccessContext.Provider>
  );
};